import React, { useEffect } from "react";
import Chart from "react-apexcharts";

function BarChart(props) {
  const scrollToBottom = () => {
    const element = document.getElementById("barchart-wrapper");
    element.scrollTop = element.scrollHeight;
  };

  useEffect(() => {
    scrollToBottom();
  });

  return (
    <div>
      <Chart
        options={props.options}
        series={props.series}
        type="bar"
        width="100%"
        height={props.options.xaxis.categories.length * 24.7}
      />
    </div>
  );
}

export default BarChart;
